var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-img',{attrs:{"alt":"Wappen der PV Bund","src":"/public/downloads/directories/images/Wappen.png","fluid":""}}),_c('LandingPage',{attrs:{"msg":"Willkommen bei der PV Bund 1895 zu Bruchsal"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }